import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { TagModalForm } from './form';
import React, { useState } from 'react';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { SimpleModal } from '@livable/saas-react-components';
export const TagManagerModal = observer(_ref => {
  let trigger = _ref.trigger,
    disabled = _ref.disabled,
    handleResetTags = _ref.handleResetTags;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    disabled: disabled,
    'custom-attribute': '432-TagManagerModal'
  }, t('admin_page.manage_tags'));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    isOpen: modalOpen,
    handleOpen: () => {
      if (!disabled) setModalOpen(true);
    },
    handleClose: () => {
      setModalOpen(false);
      handleResetTags();
      trigger();
    },
    title: t('admin_page.manage_tags'),
    trigger: defaultTrigger,
    noFooter: true
  }, /*#__PURE__*/React.createElement(TagModalForm, null));
});